<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Add Settings"
              bc1="App"
              bc2="Add Settings"
              bc3="Add"
              path="acquirings"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">

        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Min Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="min"

                                  class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Max Limit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="max"

                                  class="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <PaymentMethodSettings
                          :modelValue.sync="paymentMethodSelectedSettings"
                          ref="payemntSetting"
                      >
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Acqurinng</label>
                            </div>
                            <div class="col-sm-9 ">
                              <div class="input-group">
                                <select class="custom-select custom-select-sm" v-model="selectedAcquiring">
                                  <option value="">Please Select Acquiring</option>
                                  <option :value="item.id" v-for="(item,index) in acqurings" :key="index">
                                    {{ item.name + '/' + item.code }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Duplicate Charges Acquiring (optional) </label>
                            </div>
                            <div class="col-sm-9 ">
                              <div class="input-group">
                                <select class="custom-select custom-select-sm" v-model="duplicateChargesAcquiringId">
                                  <option :value="null">Please Select Duplicate Charges Acquiring</option>
                                  <option :value="item" v-for="(item,index) in duplicateChargesAcquiringData" :key="index">
                                    {{ item.aquiring.name + '/' + item.aquiring.code }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </PaymentMethodSettings>

                      <div class="col-sm-9 offset-sm-3 d-flex justify-content-end mt-1">
                        <button
                            type="button"
                            class="btn btn-primary "
                            @click="askForConfirmation"
                            :disabled="loading"
                        >
                          <span class="d-inline-flex"><Loader :loading="loading" :size="size"></Loader></span>
                          Save Details
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CustomConfirmationModal :show="showConfirmationModal" @confirm="confirm" :message="msg"
                       title="Please Confirm"
                       @hide="denied"></CustomConfirmationModal>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import CustomConfirmationModal from "./customConfirmationModal.vue";

export default {
  components:{
    CustomConfirmationModal
  },
    mounted() {
        var schemaAquirngs = this.$store.getters.getByKey("acquiringSchemaDetailsList");
        this.schemaId = schemaAquirngs.row.id;
        this.duplicateChargesAcquiringData = schemaAquirngs.row.schema_aquirings;
    },
    data() {
        return {
            duplicateChargesAcquiringData: [],
            showConfirmationModal: false,
            msg:'',
            duplicateChargesAcquiringId: null,
            settings: {},
            code: "",
            type: "",
            loading: false,
            size: "10px",
            paymentId: "",
            aquiringId: "",
            schemaId: "",
            paymentMethodSelectedSettings: {},
            transactionTypes: [],
            min: "",
            max: "",
            acqurings: [],
            selectedAcquiring: ""
        };
    },
    methods: {
        confirm() {


            this.saveData()
        },
        denied() {

            this.duplicateChargesAcquiringId = null;

            this.saveData()
        },
        askForConfirmation() {
          if(this.duplicateChargesAcquiringId){
            this.msg = `Are you sure to duplicate charges of ${this.duplicateChargesAcquiringId.aquiring.name+'/'+this.duplicateChargesAcquiringId.aquiring.code} acquiring for this acquiring?`
            this.showConfirmationModal = true;
          }else{
            this.saveData()
          }

        },
        saveData() {
            if (this.code == "0001" || this.code == "0002" || this.code == "0003") {
                if (this.$refs.payemntSetting.clear) {
                    this.settings = null;
                    this.paymentMethodSelectedSettings.settings = this.settings;
                    this.loading = true;
                    let requestData = {
                        type: "add",
                        minLimit: this.min * 100,
                        maxLimit: this.max * 100,
                        aquiringId: this.selectedAcquiring,
                        schemaId: this.schemaId,
                        settings: JSON.stringify({}),
                    };
                    if (this.duplicateChargesAcquiringId) {
                        requestData.duplicateChargesAcquiringId = this.duplicateChargesAcquiringId.id;
                    }

                    this.makeRequest("post", "v1/update-schema-aquiring", requestData).then(callResponse => {
                      this.showConfirmationModal = false
                        if (!callResponse.error) {
                            let code = callResponse.response.data.code;
                            if (code == 200) {
                                var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey("acquiringSchemaDetailsList");
                                if (acquiringSchemaDetialListStoreData) {
                                    acquiringSchemaDetialListStoreData.row.schema_aquirings.push(callResponse.response.data.data);
                                    this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
                                }
                                this.$router.back();
                            }
                        }
                        this.loading = false;
                    });
                    return;
                }
                let validPaymentFileds = this.$refs.payemntSetting.validateAllFields();
                validPaymentFileds.validateAll().then(payValid => {
                    if (payValid) {
                        this.$validator.validateAll().then(valid => {
                            if (valid) {
                                this.loading = true;
                                let requestData = {
                                    type: "add",
                                    minLimit: this.min * 100,
                                    maxLimit: this.max * 100,
                                    aquiringId: this.selectedAcquiring,
                                    schemaId: this.schemaId,
                                    settings: JSON.stringify(this.settings),
                                };
                                if (this.duplicateChargesAcquiringId) {
                                    requestData.duplicateChargesAcquiringId = this.duplicateChargesAcquiringId.id;
                                }
                                this.makeRequest("post", "v1/update-schema-aquiring", requestData).then(callResponse => {
                                  this.showConfirmationModal = false
                                  if (!callResponse.error) {
                                        let code = callResponse.response.data.code;
                                        if (code == 200) {
                                            var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey("acquiringSchemaDetailsList");
                                            if (acquiringSchemaDetialListStoreData) {
                                                acquiringSchemaDetialListStoreData.row.schema_aquirings.push(callResponse.response.data.data);
                                                this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
                                            }
                                            this.$router.back();
                                        }
                                    }
                                    this.loading = false;
                                });
                            }
                        });
                    }
                });
                return;
            }
            this.$validator.validateAll().then(valid => {
                if (valid) {
                    this.loading = true;
                    let requestData = {
                        type: "add",
                        minLimit: this.min * 100,
                        maxLimit: this.max * 100,
                        aquiringId: this.selectedAcquiring,
                        schemaId: this.schemaId,
                        settings: JSON.stringify(this.settings),
                    };
                    if (this.duplicateChargesAcquiringId) {
                        requestData.duplicateChargesAcquiringId = this.duplicateChargesAcquiringId.id;
                    }
                    this.makeRequest("post", "v1/update-schema-aquiring", requestData).then(callResponse => {
                      this.showConfirmationModal = false
                        if (!callResponse.error) {
                            let code = callResponse.response.data.code;
                            if (code == 200) {
                                var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey("acquiringSchemaDetailsList");
                                if (acquiringSchemaDetialListStoreData) {
                                    acquiringSchemaDetialListStoreData.row.schema_aquirings.push(callResponse.response.data.data);
                                    this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
                                }
                                this.$router.back();
                            }
                        }
                        this.loading = false;
                    });
                }
            });
        },
        getAcquirings(val) {
            this.makeRequest("post", "v1/get-aquiring", { status: "active", paymentMethodId: val }, {}, false).then(callResponse => {
                if (!callResponse.error) {
                    let code = callResponse.response.data.code;
                    if (code == 200) {
                        let acqruings = callResponse.response.data.data;
                        this.acqurings = acqruings;
                        if (this.acqurings) {
                            this.selectedAcquiring = this.acqurings[0].id;
                        }
                    }
                }
            });
        }
    },
    watch: {
        paymentMethodSelectedSettings(val) {
            if (val.paymentId != this.paymentId) {
                this.paymentId = val.paymentId;
                this.getAcquirings(this.paymentId);
            }
            this.settings = val.settings;
            this.code = val.code;
        }
    },
    components: { CustomConfirmationModal }
};
</script>

